import { AxiosRequestConfig } from 'axios';
import { GetTokenFromIndexedDB } from '../../../../utils/indexedDBUtils/get-indexed-db';

export async function getAPIConfig(multipart?: boolean): Promise <AxiosRequestConfig> {
  const token = await GetTokenFromIndexedDB('authToken');
  const refreshToken = await GetTokenFromIndexedDB('refreshToken') || null;
  const authToken = token ? `Bearer ${token}` : '';
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: authToken,
      RefreshToken: refreshToken,
      // 'x-device-id': localStorage.getItem('deviceId') || '',
      'Content-Type': multipart ? 'multipart/form-data' : 'application/json',
    },
  };
  return config;
}
